import SSOProcoreWebview from './SSOProcoreWebview';
import './SSOProcoreWebview.scss';

export default SSOProcoreWebview;
